import Styled from 'styled-components';

const WaFormsPage = Styled.div`
    min-height: 100%;
    overflow-x: hidden;
    background: #f6f7fb;

    @media only screen and (max-width: 767px){
        .ant-page-header{
            padding: 16px 16px 8px;
            background: #f6f7fb;
        }
        .ant-page-header-heading{
            display: flex !important;
            flex-flow: row wrap !important;
            align-items: center !important;
            justify-content: space-between !important;
            gap: 12px;
        }
        .ant-page-header-heading-left{
            min-width: 0;
            margin: 0 !important;
        }
        .ant-page-header-heading-title{
            font-size: 22px;
            line-height: 1.25;
            color: #20253a;
            font-weight: 700;
            white-space: normal;
            text-align: left !important;
        }
        .ant-page-header-heading-sub-title{
            display: block !important;
            width: 100% !important;
            margin: 8px 0 0 !important;
            padding: 0 !important;
        }
        .ant-page-header-heading-sub-title .title-counter{
            display: inline-block;
            font-size: 13px;
            font-weight: 600;
            margin-bottom: 6px;
        }
        .ant-page-header-heading-sub-title .ant-select-auto-complete,
        .ant-page-header-heading-sub-title .ant-select{
            display: block !important;
            width: 100% !important;
        }


        .ant-page-header-heading-extra{
            float: none;
            margin: 0 !important;
            display: block !important;
        }
        .page-header-actions .ant-btn{
            min-width: 76px;
            height: 36px;
            border-radius: 6px !important;
        }
        .ant-breadcrumb{
            display: flex;
            min-width: 0;
            overflow-x: auto;
            white-space: nowrap;
        }
        .waforms-main{
            min-height: 0;
            width: 100%;
            padding: 12px 16px 24px;
            background: #f6f7fb;
        }
        .waforms-main .ant-card{
            width: 100%;
            overflow: hidden;
            margin-bottom: 14px !important;
            border: 1px solid #edf0f5;
            border-radius: 10px !important;
            background: #fff;
            box-shadow: 0 4px 12px rgba(31, 39, 79, 0.04);
        }
        .waforms-main .ant-card-body{
            padding: 14px 16px !important;
        }
        .waforms-main .ant-form-item{
            margin-bottom: 12px !important;
        }
        .waforms-main .ant-input,
        .waforms-main .ant-select-selector{
            min-height: 40px !important;
            border-radius: 8px !important;
        }
        .waforms-main .ant-row > .ant-col-12{
            flex: 0 0 100%;
            max-width: 100%;
        }
        .waforms-main .table-responsive{
            width: 100%;
            overflow-x: visible;
        }
        .waforms-main .ant-table-wrapper,
        .waforms-main .ant-spin-nested-loading,
        .waforms-main .ant-spin-container{
            width: 100%;
            max-width: 100%;
        }
        .waforms-main .ant-table{
            width: 100%;
        }
        .waforms-main .ant-table-content{
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
        }
        .waforms-main .ant-table-content table{
            min-width: 680px !important;
        }

        .waforms-main .ant-table-thead > tr > th{
            padding: 12px 14px;
            background: #f7f8fa;
            color: #424863;
            font-size: 12px;
            font-weight: 700;
            white-space: nowrap;
        }
        .waforms-main .ant-table-tbody > tr > td{
            padding: 12px 14px;
            font-size: 13px;
        }
        .waforms-main .table-actions{
            display: flex;
            align-items: center;
            gap: 8px;
        }
        .waforms-main .table-actions .ant-btn{
            width: 34px;
            height: 34px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }
        .waforms-main .ant-pagination{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin: 14px 10px;
        }
    }
`;

export { WaFormsPage };

